<template>
<b-container>
  <b-row v-if="conference.logoURL">
    <b-col>
      <b-img :src=conference.logoURL fluid alt="Responsive image"></b-img>
    </b-col>
  </b-row>
  <b-row v-if="conference.conferenceConfirmation">
    <b-col>
      <div class="confirmation" v-html="conference.conferenceConfirmation"></div>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import { db } from '../main'

export default {
  name: 'Confirmation',
  firestore () {
    return {
      conference: db.collection('Conferences').doc(this.$router.currentRoute.params.conferenceId)    
    }
  },
  data () {
    return {
      conference: {}
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Confirmation.vue